<template>
    <div class="open-app-box-wrap">
        <!-- 限定在安卓微信 -->
        <WxOpenLaunchAppLocal
            v-if="$root.isAndroid && $root.wechatAppid && $root.isWechat"
            :appid="$root.wechatAppid"
            :comId="comId"
            :extinfoProps="extinfoProps"
            @launch-error="(e) =>$root.launchError(extinfoProps)"
            @launch-success="$root.launchSuccess"
        >
            <slot></slot>
        </WxOpenLaunchAppLocal>
        <template v-else>
            <slot></slot>
        </template>
    </div>
  
</template>

<script>
import WxOpenLaunchAppLocal from '$common/components/wechat/wx-open-launch-app-local';

export default {
    name: 'wxOpenAppLayout',
    components: {WxOpenLaunchAppLocal},
    props: {
        comId: {
            type: String,
            default: ''
        },
        extinfoProps: {
            type: String,
            default: ''
        }
        
    }
}
</script>

<style>

</style>